module.exports = __webpack_public_path__ + "img/sec4_line.9338f673.png";